<template>
  <div>
    <div class="page_header" style="">
      <span class="page_title" style="flex: 1;">{{$t("route.feedback")}}</span>

      <quickQuery :isDownload="false" @handleQuery="handleQuery" @quickQuery="quickQuery" :isNow="true" style="text-align: right"/>
      <el-button  size="small" type="success" @click="add()">{{$t("feedback.新增意见反馈")}}</el-button>
    </div>
    <div class="page_container">
      <el-table
        v-loading="loading"
        border
        :size="size" 
        :data="dataList"
        style="width: 100%;"
      >
        <el-table-column prop="OpinionTitle"  :label="$t('feedback.标题')" min-width="" align="center"></el-table-column>
        <el-table-column prop="OpinionText"  :label="$t('feedback.描述')" :min-width="400" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="SubmitTime"  :label="$t('feedback.反馈时间')" :min-width="160" align="center"></el-table-column>
        <el-table-column align="center" prop="ImageData" :label="$t('feedback.相关照片')" min-width="120">
          <template slot-scope="scope">
            <!-- 处理多图片逻辑 -->
            <div v-if="scope.row.ImageData && scope.row.ImageData.trim()">
              <div class="image-group">
                <!-- 循环显示所有图片 -->
                <el-image v-for="(path, index) in getImageList(scope.row.ImageData)" :key="index"
                  :src="getImageUrl(path)" :preview-src-list="getAllImageUrls(scope.row.ImageData)"
                  style="width: 40px; height: 40px; cursor: pointer; margin-right: 5px;" fit="cover"
                  :alt="$t('路费.备注图片')">
                </el-image>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="AnswerText"  :label="$t('feedback.回复内容')" :min-width="400" align="center"></el-table-column>
        <el-table-column  :label="$t('public.Operation')" :min-width="150" align="center">
          <template slot-scope="scope">
            <el-link
              :underline="false" 
              style="margin-right:20px;color:#2A7AFF" 
              @click="detail(scope.row)">
               {{$t('public.Detail')}}
            </el-link>
            <el-link
              :underline="false" 
              style="color:#FF106E" 
              @click="del(scope.row)">{{$t("public.del")}}
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <kl-pagination v-if="total>0"
      :total="total"
      :currentPage="currentPage"
      @current-change="currentchange"
    ></kl-pagination>
    <div>
      <!-- 新增弹窗 -->
      <el-dialog class="dialog" 
        :title="$t('feedback.新增意见反馈')" :visible.sync="dialogAdd" 
        :width="(LanguageId  == 1 ||LanguageId  == 2) ? '450px' : '600px'" 
        append-to-body :close-on-click-modal="false"
        :show-close="false">
        <el-form ref="formDialog" :model="dialog" :rules="rules"  label-width="80px" :label-position="LanguageId == 1 ? 'left' : 'top'">
          <el-form-item :label="$t('feedback.标题')" prop="textTitle">
            <el-input
              :placeholder="$t('feedback.请输入内容')"
              v-model="dialog.textTitle">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('feedback.描述')" prop="textarea">
            <el-input
              type="textarea"
              :rows="10"
              :placeholder="$t('feedback.请输入内容')"
              v-model="dialog.textarea"
              maxlength="200"
              show-word-limit>
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('feedback.上传图片')">
            <el-upload  list-type="picture-card"  ref="uploadRef" name="name"
              :file-list="fileList" 
              :on-preview="handlePictureCardPreview"
              :on-exceed="onExceed"
              :limit="2"
              :before-upload="beforeUpload"
              :accept="imageAccept"
              :action="uploadAction"
              :on-change="onChange"
							:on-remove="handleRemove" 
              :on-success="onSuccess"
							:on-error="handleUploadError" 
              :auto-upload="false"
              :headers="headerFile"
              :data="{ path: 'app' }">
							<i class="el-icon-plus"></i>
						</el-upload>
            <el-dialog :visible.sync="dialogVisible" :modal="false">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button :size="size" type="primary" plain @click="cancel">{{$t("public.cancel")}}</el-button>
          <el-button :size="size" type="primary" @click="submitSave">{{$t("feedback.提交")}}</el-button>
        </span></el-dialog>
    </div>

    <div>
      <!-- 详情弹窗 -->
      <el-dialog class="dialog" :title="$t('feedback.意见反馈详情')" :visible.sync="dialogDetail" :width="(LanguageId  == 1 ||LanguageId  == 2) ? '450px' : '600px'" append-to-body :close-on-click-modal="false">
        <div>
          <div class="detailTitle">
            <span>{{$t('feedback.描述')}}</span>
            <span class="detailTimeText">{{detailSubmitTime}} {{$t("feedback.提交")}}</span>
          </div>
          <div class="detailContain">
            <div style="white-space: nowrap;margin-right:12px">{{$t('feedback.描述')}}</div>
            <el-input
              type="textarea"
              :rows="6"
              disabled
              resize="none"
              v-model="detailOpinionText">
            </el-input>
            <!-- <div style="color: #0F1A3A;line-height: 18px;text-align:left">{{detailOpinionText}}</div> -->
          </div>

          <div class="detailTitle" style="margin-top:24px">
            <span>{{$t('feedback.回复内容')}}</span>
            <span class="detailTimeText">{{detailAnswerTime}} {{$t('feedback.回复')}}</span>
          </div>
          <div class="detailContain">
            <div style="white-space: nowrap;margin-right:12px">{{$t('feedback.回复内容')}}</div>
            <el-input
              type="textarea"
              :rows="6"
              :placeholder="$t('feedback.暂无回复内容')"
              disabled
              resize="none"
              v-model="detailAnswerText">
            </el-input>
            <!-- <div style="color: #0F1A3A;line-height: 18px;">{{detailAnswerText}}</div> -->
          </div>
          <div style="margin-top:16px"></div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import quickQuery from "@/views/statistics/components/generalOrQuickQuery.vue"
import language from '@/utils/getLanguageId'
import settings from "@/settings";
import {mapState} from 'vuex'
export default {
    name: "feedback",
  components:{quickQuery},
  computed:{
    size() {
      return this.$store.getters.size
    },
    uploadAction() {
      return settings.baseUrl + 'automatic/v1/uploadFile';
    },
    ...mapState({
      token: state => state.user.token
    }),
  },
  data(){
    var checkTextarea = (rule, value, callback) => {
      if (!value || value.trim() == "") {
        return callback(new Error(this.$t('feedback.请输入反馈内容')));
      }else {
        callback();
      }
    };
    var checkTitle = (rule, value, callback) => {
      if (!value || value.trim() == "") {
        return callback(new Error(this.$t('feedback.请输入标题')));
      }else {
        callback();
      }
    };
    return{
      images:[],//接收上传至服务器返回的FileName
      imageAccept: '.jpg,.jpeg,.png,image/jpeg,image/png',
      fileList:[],//上传组件绑定的文件列表
      dialogImageUrl: '',
      dialogVisible: false,
      handleQueryData: new Date(new Date().getTime()),
      detailAnswerText:'',
      detailAnswerTime:'',
      detailOpinionText:'',
      detailSubmitTime:'',
      dialog:{
        textarea:"",
        textTitle:"",
      },
      rules:{
        textarea: [
          { validator: checkTextarea, required: true,  trigger: 'blur'  },
        ],
        textTitle: [
          { validator: checkTitle, required: true,  trigger: 'blur'  },
        ]
      },
      dialogAdd:false,
      dialogDetail:false,
      dataList:[],
      loading:false,
      currentPage:1,
      pageSize:10,
      total:0,
      LanguageId:1,
      BeginDate:"",
      EndDate:"",
      formData:[],
      headerFile:{
        token:"",
      },
      uploadTotal: 0, // 总文件数（用于判断是否全部上传完成）
      uploadCompleted: 0, // 已完成上传的文件数
      uploadFailed: false // 是否有文件上传失败
    }
  },
  methods:{
    onChange(file, fileList){
      // console.log(fileList);
      this.fileList = fileList;
    },
    onSuccess(response, file, fileList){
      // console.log(response);
      this.image.push(response.FileName);
      this.uploadCompleted++; // 已完成数+1
      this.checkUploadFinish(); // 检查是否全部完成
    },
    handleUploadError(error) {
      this.uploadFailed = true; // 标记失败
      this.uploadCompleted++; // 已完成数+1
      this.checkUploadFinish();
    },
    // 检查所有文件是否上传完成
    checkUploadFinish() {
      // 当已完成数等于总文件数时，说明全部上传完毕
      if (this.uploadCompleted === this.uploadTotal) {
        if (this.uploadFailed) {
          this.$message.error("部分文件上传失败，请重试");
          return;
        }
        // 所有文件上传成功，且this.image已收集完成，执行表单提交
        this.submitAddSave();
      }
    },
    submitAddSave(){
      this.$api.saveOpinionFeedback({
        OpinionID:0,//（增加时为0）
        OpinionText:this.dialog.textarea,
        flag:1,//（添加1、修改2、删除3）
        ImageData:this.image.join(';'),
        OpinionTitle: this.dialog.textTitle,
      })
      .then((res)=>{
        if(res.code == 200){
          this.dialogAdd = false;
          this.getData();
          this.resetForm("formDialog");
          this.dialogImageUrl = "";
          this.dialogVisible = false;
          this.fileList = [];
        }
      })
    },
    beforeUpload(file) {
      // 1. 获取文件MIME类型（如 image/jpeg）
      const fileType = file.type;
      // 2. 校验是否为图片类型（MIME以image/开头）
      const isImage = fileType.startsWith('image/');

      if (!isImage) {
        this.$message.error('只能上传图片文件（jpg、png）！');
        return false; // 阻止上传
      }

      const allowTypes = ['image/jpeg', 'image/png'];
      if (!allowTypes.includes(fileType)) {
        this.$message.error('只支持上传JPG和PNG格式的图片！');
        return false;
      }

      return true; // 允许上传
    },
    getImageList(ImageData) {
      if (!ImageData || typeof ImageData !== 'string') {
        return [];
      }
      let _img = ImageData.split(';').filter(path => path.trim());
      let getImg=[];
      _img.forEach(element=>{
        getImg.push(element.replace("longyi/",""));
      })
      return getImg;
    },
    getImageUrl(fileName) {
      // 处理空值
      if (!fileName) return '';
      // 避免重复拼接（如果fileName已包含完整URL）
      return settings.baseUrl + fileName;
    },
    getAllImageUrls(ImageData) {
      const imageList = this.getImageList(ImageData);
      return imageList.map(path => this.getImageUrl(path));
    },
    onExceed(files, fileList){
      this.$message({
        message: '最多可上传两张图片',
        type: 'warning'
      });
    },
    
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    getData(){
      this.loading = true;
      this.$api.queryOpinionFeedback({
        OpinionText:"",
        BeginDate:this.BeginDate,
        EndDate:this.EndDate,
        pageNo:this.currentPage,
        pageSize:this.pageSize
      })
      .then((res)=>{
        console.log(res);
        if(res.code == 200){
          this.dataList = res.data;
          this.loading = false;
          this.total = res.recordsTotal;
        }
      })
      .catch(e=>{
          this.loading = false;
          this.total = 0;
          this.dataList = []
      })
    },
    handleQuery(val){
      console.log(val);
      this.BeginDate = val.beginDate;
      this.EndDate = val.endDate;
      this.getData();
    },
    quickQuery(val){
      this.BeginDate = val.beginDate;
      this.EndDate = val.endDate;
      this.getData();
    },
    detail(row){
      this.dialogDetail = true;
      this.detailAnswerText = row.AnswerText;
      this.detailSubmitTime = row.SubmitTime;
      this.detailOpinionText = row.OpinionText;
      this.detailAnswerTime = row.AnswerTime;

    },
    del(row){
      this.$confirm(this.$t('feedback.确定删除该记录?'), this.$t('public.tips'), {
        confirmButtonText: this.$t('public.confirm'),
        cancelButtonText: this.$t('public.cancel'),
        type: 'warning'
      }).then(() => {
        this.$api.saveOpinionFeedback({
          OpinionID: row.OpinionID,//（增加时为0）
          OpinionText: row.OpinionText,
          flag:3,//（添加1、修改2、删除3）
        })
        .then((res)=>{
          this.$message({
            type: 'success',
            message: this.$t('public.hasDeleted')
          });
          this.getData();
        })
      }).catch(() => {
                
      });
    },
    currentchange(val) {
      this.currentPage = val;
      this.getData();
    },
    add(){
      this.resetForm("formDialog");
      this.dialogAdd = true;
      this.dialogImageUrl = "";
      this.dialogVisible = false;
      this.fileList = [];
    },
    resetForm(refName) {
      this.dialog.textarea = "";
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    },
    async submitSave(){
      // console.log(this.fileList);
      // this.$refs.uploadRef.submit();
      // return;
      this.$refs["formDialog"].validate((valid) => {
        if (valid) {
          this.image = [];
          this.uploadCompleted = 0;
          this.uploadFailed = false;
          this.uploadTotal = this.fileList.length; // 记录总文件数

          if (this.uploadTotal > 0) {
            // 有文件：先执行上传
            this.$refs.uploadRef.submit();
          } else {
            // 无文件：直接执行表单提交
            this.submitAddSave();
          }
        }else{
          
        }
          
      });
    },
    cancel(){
      this.dialogAdd = false;
      this.dialog.textarea = "";
      this.dialogImageUrl = "";
      this.dialogVisible = false;
      this.fileList = [];
    },
  },
  mounted(){
    this.LanguageId = language(this.$store.getters.locale);
    this.headerFile.token = this.token;
  },
}
</script>
<style lang="css">
  .el-tooltip__popper{font-size: 14px; max-width:50% }
</style>
<style lang="scss" scoped>
.dialog {
  ::v-deep .el-dialog__header {
    border-bottom: 1px solid #ebeef5 !important;
  }
  ::v-deep .el-dialog__body{
    padding: 16px 20px !important;
  }
}
.detailTitle{
display:flex;justify-content: space-between;font-size: 12px;color:#0F1A3A
}
.detailTimeText{
color: rgba(15,26,58,0.5);
}
.detailContain{
display:flex;justify-content: space-between;font-size: 12px;color:transparent;margin-top:9px
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  /* 图片组样式：横向排列，超出部分自动隐藏（可选） */
	.image-group {
		display: inline-flex;
		align-items: center;
		flex-wrap: nowrap;
		max-width: 100%;
		overflow: hidden;
	}
</style>